import type { BatchResponse } from '@carboncopyco/types';
import type { BatchArgs, Sort } from '@carboncopyco/types';
import type { UseLazyQuery } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import type { QueryDefinition } from '@reduxjs/toolkit/query';
import { useCallback, useState } from 'react';

/**
 * @deprecated
 * This method should not be used. Instead, use useInfiniteScroll.
 */
export const useInfiniteScrollFromCache = <
  R extends Record<string, unknown>,
  A extends BatchArgs<Sort>,
>(
  batchQuery: UseLazyQuery<QueryDefinition<A, any, any, BatchResponse<R>>>,
  args: A,
  options?: {
    keyName?: 'string';
    refetchOnFocus?: boolean;
  }
) => {
  const [isLoadingFirstBatch, setIsLoadingFirstBatch] = useState(true);
  const [trigger, { data, isLoading, error, isFetching }] = batchQuery({
    refetchOnFocus: options?.refetchOnFocus,
  });

  const fetchFirstBatch = useCallback(() => {
    setIsLoadingFirstBatch(true);
    trigger({ ...args, nextBatchCursor: null }, true)
      .unwrap()
      .then(() => {
        setIsLoadingFirstBatch(false);
      });
  }, [args, trigger]);

  const fetchNextBatch = () => {
    if (data?.items && data?.metadata.nextCursor) {
      trigger(
        {
          ...args,
          nextBatchCursor: data.metadata.nextCursor,
        },
        true
      );
    }
  };

  return {
    items: data?.items,
    totalSize: data?.metadata.totalItems,
    error,
    isLoading: isLoading || isLoadingFirstBatch,
    isLoadingBatch: isFetching && !(isLoading || isLoadingFirstBatch),
    isEmpty: data?.items && !data?.items.length,
    fetchNextBatch,
    fetchFirstBatch,
  };
};
